import { Box } from "@mui/material";
import { Custom } from "components";
import { useTheme } from "contexts";

type Props = {
  title: string;
};

export const Header = (props: Props) => {
  const { isDark, theme } = useTheme();

  return (
    <Box component="div" my={theme.spacing.md}>
      <Box
        height={40}
        maxWidth={300}
        display="flex"
        alignItems="center"
        sx={{
          borderTopLeftRadius: theme.border.radius,
          backgroundColor: theme.color.primary.accent,
          borderTopRightRadius: theme.border.circle,
          borderBottomLeftRadius: theme.border.circle,
          borderBottomRightRadius: theme.border.radius,
        }}
      >
        <Custom.Typography
          ml={theme.spacing.xxl}
          weight={theme.font.semiBold}
          color={theme.color.font.accent}
        >
          {props.title}
        </Custom.Typography>
      </Box>
      <Box
        component="div"
        sx={{
          ml: "auto",
          mt: "-1px",
          height: "1px",
          width: `calc(100% - 30px)`,
          backgroundColor: theme.color.primary.accent,
        }}
      ></Box>
    </Box>
  );
};
